<div class="fixed left-0 top-0 h-screen flex flex-col shadow-lg p-4 transition-all duration-300 overflow-hidden z-40"
     [ngClass]="sidebarClasses()">

  <div class="flex flex-col items-center mb-6 gap-2" [class.hidden]="isCollapsed">
    <ui-photo *ngIf="user.photoUrl" [isCircular]="true" [editable]="false" [size]="EComponentSize.Small" [imageUrl]="user.photoUrl"></ui-photo>
    <ui-label class="text-center" [tag]="ELabelType.SUBTITLE" [type]="textType">{{user.name || 'Nome do usuário'}}</ui-label>
  </div>

  <div class="flex-1"></div>

  <div class="mt-auto space-y-4" *ngIf="userProgress()?.length" [class.hidden]="isCollapsed">
    <ui-circular-progress *ngFor="let progress of userProgress()"
                          [percentage]="progress.percentage"
                          [color]="progress.color || EAlert.INFO"
                          [title]="progress.title"
                          [icon]="progress.icon"
                          [clickable]="progress.clickable || false"
                          (action)="onProgressClick(progress.name, progress.clickable || false)">
    </ui-circular-progress>
  </div>
</div>

<button (click)="toggleSidebar()"
        class="fixed top-1/2 transform -translate-y-1/2 bg-gray-800 text-white rounded-full w-12 h-12 flex justify-center items-center transition-all duration-300 z-50"
        [ngClass]="buttonClasses()">
  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 transform transition-all duration-200"
       [ngClass]="{'rotate-180': isCollapsed, 'rotate-0': !isCollapsed}" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
  </svg>
</button>

